export default __webpack_public_path__ + "static/media/au.5b393cb4.svg";